import katex from 'katex';

const renderBareFormulas = (content: string): string => {
	if (!content) return content;

	const parser = new DOMParser();
	const doc = parser.parseFromString(`<div>${content}</div>`, 'text/html');
	const container = doc.body?.firstChild as HTMLElement | null;
	if (!container) return content;

	const formulaRegex =
		/\\(frac|dfrac|tfrac)\s*\{[^{}]*\}\s*\{[^{}]*\}|\\sqrt\s*\{[^{}]*\}|\\[a-zA-Z]+|[A-Za-z0-9]+\s*(\^\{[^{}]+\}|\^[A-Za-z0-9]+|_\{[^{}]+\}|_[A-Za-z0-9]+)/g;

	const walker = doc.createTreeWalker(container, NodeFilter.SHOW_TEXT);
	const textNodes: Text[] = [];

	while (walker.nextNode()) {
		const node = walker.currentNode;
		if (node.nodeType === Node.TEXT_NODE) textNodes.push(node as Text);
	}

	textNodes.forEach((node) => {
		const text = node.nodeValue || '';
		if (!text) return;
		const parent = node.parentElement;
		if (parent?.closest('.katex')) return;

		formulaRegex.lastIndex = 0;
		if (!formulaRegex.test(text)) return;

		formulaRegex.lastIndex = 0;
		const rendered = text.replace(formulaRegex, (match) => {
			try {
				return katex.renderToString(match);
			} catch {
				return match;
			}
		});

		const frag = doc.createDocumentFragment();
		const temp = doc.createElement('span');
		temp.innerHTML = rendered;
		while (temp.firstChild) frag.appendChild(temp.firstChild);
		node.parentNode?.replaceChild(frag, node);
	});

	return container.innerHTML;
};

const renderDelimitedFormulas = (content: string): string => {
	if (content.search(/\$(.*?)\$/g) < 0) return content;
	return content.replace(/\$(.*?)\$/g, (outer, inner: string) => {
		try {
			return katex.renderToString(inner);
		} catch {
			return outer;
		}
	});
};

export const renderFormulas = (html: string): string => {
	if (!html) return html;
	const withDelimited = renderDelimitedFormulas(html);
	return renderBareFormulas(withDelimited);
};

export const renderFractions = (content: string): string => {
	const matches = content.match(/\d+\/\d+/g);
	matches?.forEach((match) => {
		const [numerator, denominator] = match.split('/');
		try {
			const formula = katex.renderToString(`\\frac{${numerator}}{${denominator}}`);
			content = content.replace(new RegExp(match, 'g'), formula);
		} catch {
			// leave as-is
		}
	});
	return content;
};

export const getImageUrlsFromContent = (htmlContent: string): string[] => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlContent, 'text/html');
	const images = doc.querySelectorAll('img');
	return Array.from(images).map((img) => img.src);
};
